/* eslint-disable class-methods-use-this,max-classes-per-file */

'use strict';

define('vb/private/events/notifyEventBehavior',[
  'vb/private/events/eventBehavior',
], (EventBehavior) => {
  /**
   * @typedef {import('vb/private/stateManagement/container').default} Container
   */

  /**
   * NotifyEventBehavior
   * Call event listeners, don't wait for any responses.
   */
  class NotifyEventBehavior extends EventBehavior {
    /**
     * Overrides the parent class's 'notify' method so that the fireCustomEventAction
     * doesn't wait for the listeners to finish or resolve.
     *
     * @param {Array<{ container: Container, fnc: function }>} functionWrappers - An array of objects where each object
     * contains a container and a function representing the event listener chain.
     * @returns {Promise<null>} A promise that resolves immediately with null.
     * @protected
     * @overrides
     */
    executeInternal(functionWrappers) {
      super.executeInternal(functionWrappers);
      return Promise.resolve(null);
    }
  }

  return NotifyEventBehavior;
});

